import BaseRailsRequestController from "./base_rails_request_controller";

// Connects to data-controller="data-form"
export default class extends BaseRailsRequestController {
  static targets = [
    "select",
    "preview",
    "contactPersonResult",
    "emailResult",
    "phoneResult",
    "noContactDetails",
    "contactPersonInput",
    "emailInput",
    "phoneInput",
    "privateAddressCostsHint",
    "shipmentFrame",
    "phoneCallCostsHint",
    "locationResult",
    "houseNumberResult",
    "additionResult",
    "companyNameResult",
    "locationInput",
    "houseNumberInput",
    "additionInput",
    "companyNameInput",
    "administrativeAreaInput",
    "administrativeAreaResult",
  ];

  static values = {
    errorMessage: String,
  };

  connect() {
    // TODO: Refactor this into multiple controllers with outlets to avoid using index
    this.timeSelectInitialValues = {};

    this.selectTargets.forEach((timeSelect) => {
      this.timeSelectInitialValues[timeSelect.id] = timeSelect.value;
    });

    document.addEventListener("turbo:before-stream-render", (event) => {
      if (event.target.target != "shipment_overview") return;

      const originalRender = event.detail.render;

      const self = this;
      event.detail.render = function (streamElement) {
        originalRender(streamElement);

        const inputTypes = ["companyName", "location", "houseNumber", "addition", "administrativeArea", "email", "phone", "contactPerson"];

        inputTypes.forEach((type) => {
          self[`${type}InputTargets`].forEach((input) => {
            input.dispatchEvent(new Event("input"));
          });
        });
      };
    });
  }

  recalculate(event) {
    const element = document.getElementById(event.params.domTarget);
    element?.classList.toggle("opacity-0", !event.target.checked);

    const formData = new FormData();
    formData.append(event.target.name, event.target.checked ? "1" : "0");

    this.shipmentFrameTarget.setAttribute("busy", "true");

    this.fetchWithProgress("patch", event.target.dataset.url, {
      responseKind: "turbo-stream",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
      })
      .catch((error) => {
        console.error("Error recalculating:", error);
        window.dispatchEvent(new CustomEvent("flash:create", { detail: { type: "danger", message: this.errorMessageValue } }));
      })
      .finally(() => {
        this.shipmentFrameTarget.removeAttribute("busy");
      });
  }

  updatePreview(event) {
    const elIndex = this.selectTargets.indexOf(event.target);

    this.previewTargets[elIndex].innerHTML = event.target.value;
  }

  previewTargetConnected(event) {
    this.previewTargets.forEach((preview, index) => {
      if (preview === event) {
        preview.innerHTML = this.selectTargets[index].value;
      }
    });
  }

  updateShipmentOverview({ params: { target } }) {
    if (!this[target]) return;

    const targetElement = event.currentTarget.dataset.dataFormTarget;
    const targets = this[targetElement + "Targets"];

    const elIndex = targets.indexOf(event.currentTarget);
    this[target][elIndex].innerHTML = event.currentTarget.value;

    this.checkIfNoContactDetails(elIndex);
  }

  checkIfNoContactDetails(elIndex) {
    this.noContactDetailsTargets[elIndex].classList.toggle(
      "d-none",
      this.contactPersonResultTargets[elIndex].innerHTML.trim() !== "" ||
        this.emailResultTargets[elIndex].innerHTML.trim() !== "" ||
        this.phoneResultTargets[elIndex].innerHTML.trim() !== ""
    );
  }

  editContactDetails({ params: { index } }) {
    this.contactPersonInputTargets[index].focus();
  }

  eraseForm({ params: { form, index } }) {
    const formElement = document.getElementById(form);

    if (formElement) {
      const inputs = formElement.querySelectorAll("input, textarea, select");

      inputs.forEach((input) => {
        if (this.timeSelectInitialValues[input.id]) {
          input.value = this.timeSelectInitialValues[input.id];
          input.dispatchEvent(new Event("change"));
          return;
        }

        if (input.type === "checkbox" || input.type === "radio") {
          if (input.checked) {
            input.click(); // Since the checkboxes trigger turbo
          }

          return;
        }

        input.value = "";
      });

      if (index !== undefined) {
        // Reset the preview targets
        this.administrativeAreaResultTargets[index].innerHTML = "";
        this.additionResultTargets[index].innerHTML = "";
        this.companyNameResultTargets[index].innerHTML = "";
        this.locationResultTargets[index].innerHTML = "";
        this.houseNumberResultTargets[index].innerHTML = "";
        this.contactPersonResultTargets[index].innerHTML = "";
        this.emailResultTargets[index].innerHTML = "";
        this.phoneResultTargets[index].innerHTML = "";
        this.noContactDetailsTargets[index].classList.remove("d-none");
      }
    }
  }

  disableAdditionalInsurance(event) {
    const checkbox = event.currentTarget;
    const formData = new FormData();
    formData.append(checkbox.name, checkbox.checked ? "1" : "0");

    this.fetchWithProgress("patch", event.params.url, {
      body: formData,
      responseKind: "turbo-stream",
    })
      .then((response) => {
        if (!response.ok) {
          checkbox.checked = !checkbox.checked; // Revert checkbox state
          throw new Error("Network response was not ok");
        }
      })
      .catch((error) => {
        console.error("Error handling request:", error);
        window.dispatchEvent(new CustomEvent("flash:create", { detail: { type: "danger", message: this.errorMessageValue } }));
      });
  }
}
